export default {
    title: 'Löschen',
    deleteAction: 'Keinen Nutzer löschen | {count} Nutzer löschen | {count} Nutzer löschen',
    reallyDelete: 'Möchten Sie die ausgewählten Nutzer wirklich löschen?',
    deletedUsers: 'Die Nutzer wurden gelöscht.'
}